import { setTrackingId } from "client/Misc/utils";
import { flattenChildren, getReactNodeKey } from "client/Misc/reactUtils";
import {
	PropsWithChildren,
	ReactElement,
	ReactNode,
	useMemo
} from "react";
import styles from "./MediaCardGrid.module.less";

export type MediaCardGridProps = {
	trackingId: string;
};

export const MediaCardGrid = (props: PropsWithChildren<MediaCardGridProps>): ReactElement => {
	const {
		children,
		trackingId
	} = props;

	const childrenToRender = useMemo(
		(): ReactNode[] => flattenChildren(children)
			.slice(0, 3),
		[children]
	);

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{childrenToRender.map((x, i): ReactElement => (
				<li
					key={getReactNodeKey(x, i)}
					className={styles.item}
				>
					{x}
				</li>
			))}
		</ul>
	);
};
MediaCardGrid.displayName = "MediaCardGrid";
